"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var numberFormat_1 = __importDefault(require("../../utils/numberFormat"));
var getCurrencySymbol_1 = __importDefault(require("../../utils/getCurrencySymbol"));
var CarsItemCredit = function (_a) {
    var leasingPayment = _a.leasingPayment, creditPayment = _a.creditPayment, currency = _a.currency;
    var items = [
        {
            label: 'в кредит от',
            value: creditPayment,
        },
        {
            label: 'в лизинг от',
            value: leasingPayment,
        },
    ];
    var isHasBothPayments = leasingPayment && creditPayment;
    var currencySymbol = getCurrencySymbol_1.default(currency);
    var renderItems = items.map(function (_a) {
        var label = _a.label, value = _a.value;
        return !!value &&
            value !== 0 && (react_1.default.createElement("div", { className: "col px-2", key: label },
            react_1.default.createElement("div", { className: "aui-CarsItemCredit__label" },
                label,
                ":"),
            numberFormat_1.default()(value),
            react_1.default.createElement("span", { className: "aui-CarsItemCredit__currency" }, " " + currencySymbol + "/\u043C\u0435\u0441")));
    });
    var render = (react_1.default.createElement("div", { className: classnames_1.default('aui-CarsItemCredit', 'px-2', {
            'mt-3': isHasBothPayments,
            'col-12': isHasBothPayments,
            'col-auto ml-auto': !isHasBothPayments,
        }) },
        react_1.default.createElement("div", { className: "row mx-n2" }, renderItems)));
    return creditPayment || leasingPayment ? render : null;
};
CarsItemCredit.displayName = 'CarsItemCredit';
exports.default = CarsItemCredit;
